import React from 'react'
import CSSModules from 'react-css-modules'
import styles from './FieldWarningMsg.scss'

const FieldWarningMsg = ({ children, disabled }) => (
	<div styleName={disabled ? 'warning-disabled' : 'warning'}>
		<div styleName="description">{children}</div>
	</div>
)

FieldWarningMsg.propTypes = {}

export default CSSModules(FieldWarningMsg, styles)



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Form/FieldWarningMsg.js